import type { JSX } from 'react'
import { Link, Notice } from '@buffer-mono/popcorn'

export function AssistedBillingNotice(): JSX.Element {
  return (
    <Notice variant="neutral">
      <Notice.Text>
        Your account is billed manually. To change your plan or channel
        allowance, contact Support at{' '}
        <Link href="mailto:support@buffer.com">support@buffer.com</Link>.
      </Notice.Text>
    </Notice>
  )
}
